AgrimarketServices.service('moduleService', ['$rootScope', '$http', '$location', 'currentUserFactory', 'configurationFactory','enumFactory',
	function ($rootScope, $http, $location, currentUserFactory, configurationFactory, enumFactory) {

		var SendRequest = function (configfile, callback) {
			$http(configfile)
				.success(function (data) {
					callback(data, null, null, null);
				})
				.error(function (data, status, headers, config) {
					callback(data, status, headers, config);
				});
		};

		this.GetModuleMicrosoftEntraID = function (callback) {
			var config = {
				method: 'GET',
				url: configurationFactory.Url['Api'] + 'Module/GetModuleMicrosoftEntraID'
			};
			SendRequest(config, callback);
		};
	}]);